<template>
  <div class="editPage__box--div">
    <div class="item__div">
      <span>{{ type == 1 ? '页面标题:' : '组件标题:' }}</span>
      <a-input class="input__col" v-model="edit.title" size="large"/>
    </div>
    <div class="item__div">
      <span>{{ type == 1 ? '页面编码:' : '组件名称:' }}</span>
      <a-input class="input__col" v-model="edit.name" size="large"/>
      <div class="item__div--tips" v-if="!nameStatus">
        {{ type == 1 ? '请输入大写驼峰格式的页面编码,如：TestPage:' : '请输入大写驼峰格式的组件名称,如：TestComponent' }}
      </div>
    </div>
    <div class="item__div">
      <span>{{ type == 1 ? '页面描述::' : '组件描述:' }}</span>
      <a-textarea class="input__col" v-model="edit.description" size="large"/>
    </div>
    <div class="item__div">
      <span>标签:</span>
      <SelectTags @getTags="handleChange" @getTagsName="getTagsName" @tagFocus="getTagParams" :queryParams="tagParams" defaultSize="large" :selectedList="edit.tagIds == '' ? [] : edit.tagIds.split(',')"/>
    </div>
    <div class="item__div">
      <span>项目权限:</span>
      <PermissionsChoose @selectRido="getRidoVal" :multiple="false" :checked="edit.visibility"/>
    </div>
  </div>
</template>
<script>
import SelectTags from '@/views/project/list/components/SelectTags'
import PermissionsChoose from '@/views/component/permissionsChoose/index'

export default {
  name:'EditPage',
  components:{
    SelectTags,
    PermissionsChoose
  },
  props:{
    editData:{
      type: Object
    },
    type: {
      type: [ String, Number ]
    }
  },
  watch: {
    "edit.name": {
      handler: function (val) {
        let patt = new RegExp(/^[A-Z][a-zA-Z0-9]{1,}$/g)
        if (this.type == 1) {
          this.nameStatus = patt.test(val)
          this.$emit('nameStatusChange',this.nameStatus)
        }
      }
    }
  },
  created(){
    // console.log(this.editData,"editData")
    this.edit = this.editData
  },
  data () {
    return {
      edit:{},
      tagParams:{},
      nameStatus: true,
    }
  },
  methods:{
    handleChange(val){
      this.edit.tagIds = val.join(',')
    },
    getRidoVal(val){
      this.edit.visibility = val
    },
    getTagsName(val) {
      this.edit.tagNames = val
    },
    /**
     * 获取请求的参数
     */
    getTagParams(){
      this.tagParams = {
        dataType:'page',
        params:{
          pageNo:1,
          pageSize:10,
          type:1
        }
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>